<template>
  <c-dropdown placement="bottom-end" ref="menu">
    <div class="navbar__item">
      <a role="button" class="navbar__item">
            <span class="i-text">
                <i class="icon-user"></i>
                <span>{{userFullName}} ({{clientName}})</span>
            </span>
        <div class="account__after">
          <i class="i-caret i-caret--light"></i>
        </div>
      </a>
    </div>
    <c-dropmenu slot="content">
      <c-dropmenu-item title="User Profile" @click="onProfile"></c-dropmenu-item>
      <c-dropmenu-item title="Multi-Factor Authentication" @click="onMFA"></c-dropmenu-item>
      <c-dropmenu-divider/>
      <c-dropmenu-item title="Logout" @click="onLogout"/>
    </c-dropmenu>
  </c-dropdown>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'UserInfoDisplay',

  computed: {
    ...mapState('auth', ['userFullName', 'clientName'])
  },

  data () {
    return {
    }
  },

  methods: {
    onProfile () {
      this.$refs.menu.hide()
      this.$router.push({name: 'UserProfile'})
    },
    onMFA () {
      this.$refs.menu.hide()
      this.$router.push({name: 'User2FA'})
    },
    onLogout () {
      this.$auth.logout()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UserInfoDisplay.vue